// This file was automatically generated from appchart.visitNote.twoCol.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.twoCol');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.field = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><label class="el8label">', soy.$$escapeHtml(opt_data.label), '</label><ol id="visit-note-list-', soy.$$escapeHtml(opt_data.name), '"></ol><textarea type="text" class="w100" name="', soy.$$escapeHtml(opt_data.name), '"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldReason = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section el8FieldSection sectionExamReason"><label class="el8label el8FieldExtraLong el8LgText">Exam Reason (CC):</label><input type="text" class="el8LgText w100" name="examReason" autocomplete="off"/></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldAllergies = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'Allgy:', name: 'allergies'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldData = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'Data:', name: 'data'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldAssessment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldSection">', (! opt_data.isVisitNoteTemplate) ? '<div class="alignRight"><a tabindex="-1" id="assessments-mark-all-trigger" class="el8FormLink">Mark All Assessments As<span class="el8DownArrowIcon"></span></a></div>' : '', '<ol id="visit-note-list-assessment"></ol><div class="fieldNoteSection"><textarea type="text" class="w100" name="assessment"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldTest = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><label class="el8label">Tests:</label><div class="fieldLabelContainerNoBorder"><ol id="visit-note-owned-list-test" class="owned-docs"></ol></div><ol id="visit-note-list-test"></ol><textarea type="text" class="w100" name="test"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldTx = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><label class="el8label">Tx:</label><div class="fieldLabelContainerNoBorder"><ol id="visit-note-owned-list-tx" class="owned-docs"></ol></div><ol id="visit-note-list-tx"></ol><textarea type="text" class="w100" name="tx"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldAssessplan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldSection">', (! opt_data.isVisitNoteTemplate) ? '<div class="alignRight"><a tabindex="-1" id="assessments-mark-all-trigger" class="el8FormLink">Mark All Assessments As<span class="el8DownArrowIcon"></span></a></div>' : '', '<ol id="visit-note-list-assessplan"></ol><div class="fieldNoteSection"><textarea type="text" class="w100" name="assessplan"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldInstr = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><p class="fieldTitle">Care Plan:</p><ol id="visit-note-list-instr"></ol><div class="fieldSection"><textarea type="text" class="w100" name="instr"></textarea></div></div>', (! opt_data.isVisitNoteTemplate) ? '<div class="actionFieldButton"><a tabindex="-1" id="note-new-visit-print-instructions-btn" class="el8FormLink">Print Care Plan</a></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldProcedure = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldSection"><label class="el8label">Proc:</label><ol id="visit-note-list-procedure"></ol><div class="fieldNoteSection"><textarea type="text" class="w100" name="procedure"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldProblem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldSection"><ol id="visit-note-list-problem"></ol><div class="fieldNoteSection"><textarea type="text" class="w100" name="problem"></textarea></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldPast = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'PMH:', name: 'past'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldSurgical = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'PSH:', name: 'surgical'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldFamily = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'FH:', name: 'family'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldSocial = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'SH:', name: 'social'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldHabits = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.visitNote.twoCol.field({label: 'Habits:', name: 'habits'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldMed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><label class="el8label">Meds:</label><div class="fieldLabelContainerNoBorder"><ol id="visit-note-owned-list-med" class="owned-docs"></ol></div><ol id="visit-note-list-med"></ol><textarea type="text" class="w100" name="med"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldPe = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><label class="el8label">PE:</label><ol id="visit-note-list-pe"></ol><textarea type="text" class="w100" name="pe"></textarea><span id="pe-detail-checklist-form"></span></div><div class="actionFieldButton"><ul class="el8ButtonContainer"><li class=""><a tabindex="-1" id="pe-detail-checklist-trigger" class="el8FormLink pe-detail-checklist-trigger">PE Checklist</a></li><li class=""><a tabindex="-1" id="pe-detail-templates-trigger" class="el8FormLink pe-detail-templates-trigger">PE Templates<span class="el8DownArrowIcon"></span></a></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldRos = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-section fieldNoteSection"><label class="el8label">ROS:</label><ol id="visit-note-list-ros"></ol><textarea type="text" class="w100" name="ros"></textarea><span id="ros-detail-checklist-form"></span></div><div class="actionFieldButton"><ul class="el8ButtonContainer"><li class=""><a tabindex="-1" id="ros-detail-checklist-trigger" class="el8FormLink ros-detail-checklist-trigger">ROS Checklist</a></li><li class=""><a tabindex="-1" id="ros-detail-templates-trigger" class="el8FormLink ros-detail-templates-trigger">ROS Templates <span class="el8DownArrowIcon"></span></a></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldFollowup = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label class="el8label">F/U:</label><textarea type="text" class="w100" name="followup"></textarea>', (! opt_data.isVisitNoteTemplate) ? '<div class="el8FieldShortLabelPadding"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><a tabindex="-1" id="note-new-visit-print-summary-btn" class="el8FormLink">Print Patient Summary</a></li><li class="el8ButtonItem"><a tabindex="-1" id="note-new-visit-print-clinical-summary-btn" class="el8FormLink">Print Clinical Summary of Encounter (MIPS)</a></li></ul></div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldReferenced = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="visit-note-section-referenced" class="visit-note-section fieldNoteSection"><div class="el8FieldShortLabelPadding el8Wrap"><div class="el8AppText">Documents Referenced:</div><ol id="visit-note-list-referenced"></ol></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.twoCol.fieldOrders = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="visit-note-section-orders" class="visit-note-section fieldNoteSection"><label class="el8label">Orders:</label><div class="el8FieldShortLabelPadding el8Wrap"><ol id="visit-note-list-orders"></ol></div></div>');
  if (!opt_sb) return output.toString();
};
